import { AnimatedSprite, Container, Graphics, LINE_CAP, LINE_JOIN, Sprite, Text } from 'pixi.js';
import { TextureFactory } from '../core';
import PlayerTextureInfo from '../class/jumping/Player.json';

class JumpingGameProgress extends Container {
  private line: Graphics;
  private flag: Sprite;
  public ninimos: Record<string, Container> = {};
  private stageWidth: number = 0;
  private stageHeight: number = 0;

  constructor(players: Array<{ code: string; name: string }> = [{ code: 'player', name: '' }]) {
    super();

    this.line = new Graphics();
    this.addChild(this.line);

    this.flag = new Sprite(TextureFactory.instance.getSingleTexture('/textures/ui/flag.png'));
    this.flag.scale.set(0.2);
    this.flag.anchor.set(0.5, 1);
    this.addChild(this.flag);

    const textures = TextureFactory.instance.load(PlayerTextureInfo);
    for (const { code, name } of players) {
      const animatedSprite = new AnimatedSprite(textures.slice(158, 173));
      this.ninimos[code] = new Container();
      animatedSprite.anchor.set(0.6, 0.9);
      animatedSprite.scale.set(0.25);
      animatedSprite.animationSpeed = 0.4;
      animatedSprite.play();

      const nameText = new Text(name, {
        fontSize: 16,
        fontFamily: 'gaegu',
        fontWeight: '400',
        fontStyle: 'normal',
        fill: '0x492A2E',
        stroke: '0xffffff',
        strokeThickness: 4,
        lineJoin: 'round',
        padding: 10,
      });
      nameText.anchor.set(0.5);
      nameText.position.set(0, -50);

      this.ninimos[code].addChild(animatedSprite);
      this.ninimos[code].addChild(nameText);
      this.addChild(this.ninimos[code]);
    }
  }

  public update(width: number, height: number, progress: number, code: string = 'player'): void {
    if (progress >= 1) progress = 1;

    if (this.stageWidth !== width || this.stageHeight !== height) {
      this.stageWidth = width;
      this.stageHeight = height;
      this.redraw();
    }

    const padding = 80;
    this.ninimos[code].x = padding / 4 + 20;
    this.ninimos[code].y +=
      (this.stageHeight - padding - 20 - (this.stageHeight - padding * 2 - 40) * progress - this.ninimos[code].y) * 0.1;
  }

  private redraw(): void {
    const padding: number = 80;

    this.line.clear();

    this.line.beginFill(0x555555, 0.5);
    this.line.drawRoundedRect(padding / 4, padding, 40, this.stageHeight - padding * 2, 10);
    this.line.endFill();

    this.line.lineStyle({
      width: 4,
      color: 0x475153,
      cap: LINE_CAP.ROUND,
      join: LINE_JOIN.ROUND,
    });
    this.line.moveTo(padding / 4 + 20, padding + 20);
    this.line.lineTo(padding / 4 + 20, this.stageHeight - padding - 20);

    this.flag.x = padding / 4 + 20;
    this.flag.y = padding + 20;
  }
}

export default JumpingGameProgress;
